import type { CommissionOrgChartPerson } from './types';

export function fmtBrl(value: number) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function initials(name: string) {
    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p.charAt(0).toUpperCase())
        .join('');
}

export function personFirstName(name: string) {
    return name.trim().split(/\s+/)[0] ?? name;
}
